/* window.location.origin might be empty for internet explorer users.
 * that's a problem with our block loader as it redirects if the json response contains the key "redirect".
 * such redirects are used for example in the /newapplicant, /newproject and /newcompany routes.
 *
 * @see BlockLoader.js
 * @see Esearcher\Controller\Applicant\TabController::saveApplicantAction()
 */
if (!window.location.origin) {
    window.location.origin =
        window.location.protocol + "//" + window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
}